import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { Grid, Typography } from '@mui/material';
import { CustomField } from '@/components/shared/CustomField';
import * as state from '@/components/Analysis/state';

interface DWOProps {
  onFieldValueChange: (value: string, fieldKey: string | undefined | null) => void;
  requiredDWOKeys: Set<string>;
}

export const DwoComponent = ({ onFieldValueChange, requiredDWOKeys }: DWOProps) => {
  const assemblyTemplate = useAtomValue(state.assemblyTemplate);
  const getFieldType = useCallback((fieldKey: string | undefined | null, fieldType: string) => {
    if (fieldKey === 'equipment_tag') {
      return 'INPUT';
    }
    if (fieldType === 'MULTI_SELECT') {
      return 'SINGLE_SELECT';
    }
    return fieldType;
  }, []);

  return (
    <>
      <Typography sx={{ fontWeight: 'bold' }}>Required fields</Typography>
      <Grid container spacing={2}>
        {assemblyTemplate?.fields
          .filter((field) => typeof field?.key === 'string' && requiredDWOKeys.has(field.key))
          .map((field, index) => {
            const fieldId = field.id;
            const fieldOptions = field.options;
            const fieldName = field.name;
            const fieldKey = field?.key;
            const fieldType = getFieldType(fieldKey, field.type);
            return (
              <Grid item xs={index ? 6 : 12} key={fieldId}>
                <CustomField
                  key={fieldId}
                  fieldName={fieldName}
                  fieldType={fieldType}
                  fieldOptions={fieldOptions}
                  initialValue=""
                  onChange={(value) => onFieldValueChange(value, fieldKey)}
                />
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};
